import '../../assets/scss/base/_reboot.scss';
import { QuizApp } from "./QuizApp";
import React from "react";
const App = (props) => {
    return (React.createElement(QuizApp, null));
};
export default App;
